export const categories = [
  {
    id: 'sports',
    name: '体育竞技',
    icon: 'ri-football-line',
    description: '汇聚全球顶级体育赛事，实时赔率、丰富玩法，为您提供极致的体育博彩体验。涵盖足球、篮球、网球、电竞等热门项目。',
    features: ['实时赔率更新', '多玩法投注', '直播流媒体', '赛事数据分析'],
    imageSeq: 'cat-sports-01',
  },
  {
    id: 'live',
    name: '真人视讯',
    icon: 'ri-live-line',
    description: '真实赌场氛围，专业荷官发牌，高清视频直播。百家乐、轮盘、骰宝等多种经典游戏，让您身临其境感受赌场魅力。',
    features: ['真人荷官', '高清直播', '多台同玩', '互动聊天'],
    imageSeq: 'cat-live-01',
  },
  {
    id: 'slots',
    name: '电子游艺',
    icon: 'ri-gamepad-line',
    description: '上千款精选老虎机与电子游戏，从经典水果机到最新3D动画老虎机，丰富主题与高额奖金等您来挑战。',
    features: ['千款游戏', '高额奖池', '免费试玩', '即时到账'],
    imageSeq: 'cat-slots-01',
  },
  {
    id: 'lottery',
    name: '彩票游戏',
    icon: 'ri-ticket-line',
    description: '全球主流彩票尽在其中，时时彩、六合彩、快乐8等多种玩法，高赔率、快开奖，把握每一个中奖机会。',
    features: ['高频开奖', '多种玩法', '自动兑奖', '历史查询'],
    imageSeq: 'cat-lottery-01',
  },
  {
    id: 'esports',
    name: '电子竞技',
    icon: 'ri-computer-line',
    description: '紧跟电竞潮流，覆盖LOL、DOTA2、CS:GO等主流电竞项目。专业数据分析与实时赔率，电竞玩家的最佳选择。',
    features: ['主流赛事', '实时数据', '专业分析', '快速结算'],
    imageSeq: 'cat-esports-01',
  },
  {
    id: 'fishing',
    name: '捕鱼游戏',
    icon: 'ri-anchor-line',
    description: '精美画面与流畅操作，多种武器与技能组合，与全球玩家同台竞技，体验捕鱼的无限乐趣与丰厚回报。',
    features: ['3D画面', '多人竞技', '丰富道具', '高倍奖励'],
    imageSeq: 'cat-fishing-01',
  },
];

export const articles = [
  {
    id: '1',
    title: '开云平台荣获2025年度最佳在线娱乐平台大奖',
    slug: 'award-2025-best-platform',
    category: 'news',
    categoryName: '平台资讯',
    summary: '在刚刚揭晓的2025年度国际在线娱乐行业评选中，开云平台凭借卓越的用户体验、严格的安全体系和丰富的产品线，荣获"年度最佳在线娱乐平台"称号。',
    content: `在刚刚揭晓的2025年度国际在线娱乐行业评选中，开云平台凭借卓越的用户体验、严格的安全体系和丰富的产品线，荣获"年度最佳在线娱乐平台"称号。

本次评选由国际博彩行业协会（IGA）主办，来自全球超过200家在线娱乐平台参与角逐。评审团从平台安全性、产品丰富度、用户体验、客户服务和创新能力五个维度进行了全面评估。

开云平台在各项指标中均名列前茅，特别是在安全体系方面，开云采用的128位SSL加密技术与多重身份验证系统获得了评审团的高度认可。平台自主研发的智能风控系统能够实时监测异常交易，有效保障用户资金安全。

开云平台CEO在获奖感言中表示："这个奖项是对开云团队多年来不懈努力的肯定。我们将继续秉持'安全第一、用户至上'的理念，为全球用户提供更优质的服务。"

此次获奖进一步巩固了开云平台在行业中的领先地位，也为平台未来的国际化发展战略注入了强劲动力。`,
    author: '开云资讯',
    date: '2025-12-15',
    readTime: '5分钟',
    imageSeq: 'article-award-01',
  },
  {
    id: '2',
    title: '开云平台安全体系全面升级，多重防护保障用户资金安全',
    slug: 'security-upgrade-2025',
    category: 'security',
    categoryName: '安全公告',
    summary: '开云平台宣布完成新一轮安全体系升级，引入区块链存证技术与AI智能风控系统，为用户提供银行级的安全保护。',
    content: `开云平台今日宣布完成新一轮安全体系全面升级，此次升级涵盖数据加密、资金托管、身份验证和风险控制四大核心模块。

在数据加密方面，平台将加密标准从此前的256位AES升级至量子安全级别的加密算法，确保所有用户数据传输和存储的安全性达到金融行业最高标准。

资金安全方面，开云平台与多家国际知名银行达成战略合作，实现用户资金第三方托管。所有用户资金均存放于独立托管账户，与平台运营资金完全隔离，从制度上保障了用户资金安全。

身份验证系统引入了生物识别技术，支持人脸识别、指纹验证等多种方式，有效防止账户盗用风险。同时，双因素认证（2FA）已成为平台标配，用户可通过手机验证码或身份验证器App进行二次确认。

AI智能风控系统是本次升级的亮点。该系统能够实时分析用户行为模式，精准识别异常操作，在潜在风险发生前主动预警并采取保护措施。系统上线以来，已成功拦截超过10万次可疑操作。

开云平台安全总监表示："安全是开云的生命线。我们将持续投入资源，确保每一位用户都能在开云平台享受到安全、放心的娱乐体验。"`,
    author: '开云安全团队',
    date: '2025-11-28',
    readTime: '6分钟',
    imageSeq: 'article-security-01',
  },
  {
    id: '3',
    title: '开云平台新用户专享：注册即送豪华礼包，首存百分百回馈',
    slug: 'new-user-welcome-bonus-2026',
    category: 'promotion',
    categoryName: '优惠活动',
    summary: '开云平台推出2026年度新用户重磅福利活动，新注册用户即可领取价值888元豪华礼包，首次存款更享100%返还优惠。',
    content: `为回馈广大用户的支持与信任，开云平台正式推出2026年度新用户专享福利活动。

活动期间，所有新注册并完成实名认证的用户，均可立即领取价值888元的豪华新人礼包，礼包含有免费旋转、体育免费投注、真人视讯体验金等多种奖励。

首次存款优惠更是诚意满满：新用户首次充值任意金额，即可获得等额返还，最高返还金额达1888元。返还金额可直接用于平台任意游戏，且提现门槛极低。

除了新用户福利外，平台还同步推出了"老带新"奖励计划。老用户每成功邀请一位新用户注册并完成首存，即可获得88元推荐奖励，上不封顶。

开云平台运营负责人表示："我们希望通过实实在在的优惠活动，让每一位新朋友都能充分体验开云平台丰富的产品和服务。同时，也感谢老用户一直以来的支持，老带新计划是我们对忠实用户的一份心意回馈。"

活动详情请登录开云官网查看活动规则，机会难得，不容错过。`,
    author: '开云运营团队',
    date: '2026-01-05',
    readTime: '4分钟',
    imageSeq: 'article-promo-01',
  },
  {
    id: '4',
    title: '开云平台支付系统升级：支持数字货币，到账速度提升至秒级',
    slug: 'payment-system-digital-currency',
    category: 'tech',
    categoryName: '技术动态',
    summary: '开云平台支付系统完成重大升级，全面支持USDT、BTC等主流数字货币，存提款到账速度提升至秒级，用户体验再上新台阶。',
    content: `开云平台今日宣布支付系统完成重大升级，正式全面支持数字货币充值与提现功能。

此次升级后，用户可使用USDT（TRC20/ERC20）、BTC、ETH等主流数字货币进行账户充值和提现操作。相比传统支付方式，数字货币支付具有到账速度快、手续费低、隐私性强等显著优势。

在到账速度方面，升级后的支付系统实现了质的飞跃。传统银行转账通常需要数小时甚至数天，而数字货币支付在区块链确认后即可秒级到账。即使是首次使用的用户，在经过简单的钱包绑定流程后，也能享受到极速支付体验。

安全方面，开云平台的数字货币支付系统采用多重签名与冷热钱包分离技术，确保用户数字资产安全。所有交易均记录在区块链上，公开透明、不可篡改。

此外，平台还优化了法币充提通道，与多家支付服务商达成合作，支持支付宝、微信支付、银联等多种方式，满足不同用户的支付偏好。

开云平台技术副总裁表示："支付体验是在线娱乐平台的核心竞争力之一。我们将持续优化支付系统，让用户享受到更快、更安全、更便捷的资金服务。"`,
    author: '开云技术团队',
    date: '2025-10-20',
    readTime: '5分钟',
    imageSeq: 'article-payment-01',
  },
  {
    id: '5',
    title: '开云平台VIP会员体系全新升级，尊享十项专属权益',
    slug: 'vip-system-upgrade-2025',
    category: 'news',
    categoryName: '平台资讯',
    summary: '开云平台VIP会员体系迎来全面升级，新增专属客服、优先提现、生日礼遇等十项尊享权益，为高端用户提供更贴心的服务体验。',
    content: `开云平台VIP会员体系今日宣布全面升级，新的VIP体系分为青铜、白银、黄金、铂金、钻石五个等级，每个等级享有对应的专属权益。

升级后的VIP体系新增了多项实用权益：专属1对1客服经理、优先提现通道（提现处理速度提升3倍）、每月免费提现次数增加、专属优惠活动优先参与权、生日专属礼遇、VIP专属游戏厅、高额投注限额提升、亏损返水比例提升、线下活动邀请资格以及季度专属礼品。

升级规则更加透明：用户只需满足当月累计存款金额与有效投注额两个条件，即可自动升级至对应VIP等级。系统每月1日自动评估，升级即时生效，且等级只升不降，充分保障用户权益。

值得一提的是，新VIP体系还加入了"VIP管家服务"——黄金及以上等级的VIP用户均可享受专属管家服务，包括但不限于行程规划、酒店预订、机场接送等生活便利服务。

开云平台客户关系总监表示："VIP会员是我们最宝贵的财富。通过这次升级，我们希望让每一位VIP会员都能感受到开云的诚意与温度，享受到超越期待的服务体验。"`,
    author: '开云VIP服务部',
    date: '2025-09-15',
    readTime: '5分钟',
    imageSeq: 'article-vip-01',
  },
  {
    id: '6',
    title: '开云平台责任博彩体系获国际认证，倡导健康娱乐理念',
    slug: 'responsible-gaming-certification',
    category: 'news',
    categoryName: '平台资讯',
    summary: '开云平台责任博彩体系通过国际责任博彩协会（IRGA）认证，成为亚洲首批获得该认证的在线娱乐平台之一。',
    content: `开云平台今日宣布，其责任博彩管理体系已正式通过国际责任博彩协会（IRGA）的严格审核，获得IRGA铂金级认证。开云平台由此成为亚洲地区首批获此殊荣的在线娱乐平台。

IRGA认证是全球责任博彩领域最具权威性的认证之一，其审核标准涵盖预防措施、干预机制、自我限制工具、员工培训、信息披露等12个维度、86项具体指标。

开云平台在责任博彩方面建立了完善的防护体系：
- 存款限额设置：用户可自行设置每日、每周、每月的存款上限
- 损失限额设置：可设置一定时期内的最大损失额度
- 时间提醒功能：定时弹窗提醒用户已游戏时长
- 冷静期功能：用户可选择短期或长期暂停账户
- 自我排除计划：提供6个月至5年的自我排除选项
- 未成年保护机制：严格的身份验证杜绝未成年人参与

此外，平台还设有专门的责任博彩咨询团队，为用户提供免费的咨询服务。所有员工均需接受责任博彩培训并通过考核。

开云平台社会责任总监强调："作为行业领先平台，我们深知肩上的社会责任。开云始终倡导健康娱乐理念，致力于为用户营造安全、负责任的娱乐环境。"`,
    author: '开云社会责任部',
    date: '2025-08-22',
    readTime: '6分钟',
    imageSeq: 'article-responsible-01',
  },
];

export const faqs = [
  {
    question: '如何注册开云平台账号？',
    answer: '点击官网右上角"注册"按钮，填写手机号码、设置登录密码，完成短信验证码验证后即可成功注册。注册过程仅需1分钟，简单快捷。建议注册后立即完成实名认证，以便享受完整的平台服务。',
  },
  {
    question: '开云平台支持哪些支付方式？',
    answer: '开云平台支持多种支付方式，包括：支付宝、微信支付、银联转账、USDT（TRC20/ERC20）、BTC、ETH等。充值即时到账，提现快速处理，满足不同用户的支付需求。',
  },
  {
    question: '如何保障账户资金安全？',
    answer: '开云平台采用银行级安全防护体系：128位SSL加密传输、第三方资金托管、AI智能风控系统、多重身份验证。所有资金与平台运营资金完全隔离，确保您的资金安全无虞。',
  },
  {
    question: '开云平台的客户服务时间是？',
    answer: '开云平台提供7×24小时全天候客户服务，您可以通过在线客服、官方邮箱或VIP专属热线随时联系我们的客服团队。我们的客服人员经过专业培训，能够快速响应并解决您的问题。',
  },
  {
    question: '忘记密码如何找回？',
    answer: '在登录页面点击"忘记密码"，输入注册时使用的手机号码，系统将发送验证码至您的手机。验证通过后即可设置新密码。如遇到任何问题，可随时联系在线客服协助处理。',
  },
  {
    question: '开云平台是否支持手机端访问？',
    answer: '是的，开云平台全面支持移动端访问。您可以通过手机浏览器直接访问官网，也可以下载官方App（支持iOS和Android系统）。移动端与PC端数据同步，随时随地畅享开云服务。',
  },
];